import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "4.083 0.685 47.346 54.315"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m42.947.685-4.861 14.374H17.399L12.564.685H4.083L23.14 55h9.232L51.429.685zm-7.189 21.27L27.95 45.134h-.414l-7.809-23.179z" }, null, -1)
  ]))]))
}
export default { render: render }